/* ============================================================================
   STİL KOMBİNLERİ (LOOKBOOK)
   - Hotspot ↔ liste satırı eşleşmesi (kartlar birbirinden bağımsız)
   - Kombini toplu sepete ekleme: tek POST /cart/add.js (items dizisi)
   - Çok varyantlı ürünlerde beden zorunlu, stokta olmayanı atla
   - Başarıda cart drawer'ı Dawn deseniyle (renderContents) tazele ve aç
   ========================================================================== */
(function () {
  if (window.__tcLookbook) return;
  window.__tcLookbook = 1;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.tc-lb-card[data-look]').forEach(initCard);
    document.querySelectorAll('.tc-lb-cd-timer[data-deadline]').forEach(initCountdown);
  });

  // Modul: urun detay sayfasi (style-lookbook-product.js) ayni hotspot+sepet mantigini
  // yeniden kullanabilsin diye disa aciyoruz (kopyalama yok).
  window.TCLookbook = { initCard: initCard, initCountdown: initCountdown };

  function initCountdown(el) {
    var deadline = new Date(el.getAttribute('data-deadline')).getTime();
    if (isNaN(deadline)) return;
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]'),
        mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    var noteEl = el.parentNode.querySelector('.tc-lb-cd-note [data-days]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff < 0) diff = 0;
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      if (dEl) dEl.textContent = d;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (noteEl) noteEl.textContent = d;
      if (diff === 0) {
        if (el._t) clearInterval(el._t);
        // suresi dolan geri sayim "0:00:00:00" olarak asili kalmasin
        var wrap = el.closest ? el.closest('.tc-lb-countdown') : null;
        if (wrap) wrap.classList.add('is-expired');
      }
    }
    tick();
    el._t = setInterval(tick, 1000);
  }

  function initCard(card) {
    var dots = card.querySelectorAll('.tc-lb-dot');
    var rows = card.querySelectorAll('.tc-lb-row');
    var moneyFmt = card.getAttribute('data-money-format') || '';

    function setActive(idx) {
      dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.idx === idx); });
      rows.forEach(function (r) { r.classList.toggle('is-active', r.dataset.idx === idx); });
    }

    // toplamlar: satirlarin data-line-price/compare degerlerinden yeniden hesapla
    // (yalniz stoktaki urunler dahil — liquid sold-out satira 0 yazar)
    function recompute() {
      if (!moneyFmt || !card.querySelector('.tc-lb-row[data-line-price]')) return;
      var total = 0, compare = 0;
      rows.forEach(function (r) {
        total += parseInt(r.getAttribute('data-line-price'), 10) || 0;
        compare += parseInt(r.getAttribute('data-line-compare'), 10) || 0;
      });
      card.querySelectorAll('.tc-lb-total-now').forEach(function (el) {
        el.textContent = formatMoney(total, moneyFmt);
      });
      var oldEl = card.querySelector('.tc-lb-total-old');
      if (oldEl) {
        oldEl.textContent = formatMoney(compare, moneyFmt);
        oldEl.style.display = compare > total ? '' : 'none';
      }
      var savEl = card.querySelector('[data-savings]');
      if (savEl && compare >= total) savEl.textContent = formatMoney(compare - total, moneyFmt);
    }

    // 1) hotspot ↔ liste
    dots.forEach(function (d) {
      d.addEventListener('click', function () { setActive(d.dataset.idx); });
    });
    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { setActive(r.dataset.idx); });
      r.addEventListener('click', function () { setActive(r.dataset.idx); });
      r.addEventListener('focus', function () { setActive(r.dataset.idx); });
      r.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(r.dataset.idx); }
      });
      var sel = r.querySelector('select.tc-lb-variant');
      if (sel) sel.addEventListener('change', function () {
        r.classList.remove('needs-variant');
        // secilen varyantin fiyatini satira ve kombin toplamina yansit
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var cents = parseInt(opt.getAttribute('data-price'), 10);
        var fmtTxt = opt.getAttribute('data-price-fmt');
        if (!isNaN(cents)) {
          r.setAttribute('data-line-price', cents);
          var cmp = parseInt(r.getAttribute('data-line-compare'), 10) || 0;
          if (cmp < cents) r.setAttribute('data-line-compare', cents);
        }
        if (fmtTxt) {
          var priceEl = r.querySelector('.tc-lb-sale') || r.querySelector('.tc-lb-reg');
          if (priceEl) priceEl.textContent = fmtTxt;
        }
        recompute();
      });
    });

    // 2) kombini sepete ekle
    var btn = card.querySelector('.tc-lb-add');
    if (btn) btn.addEventListener('click', function () { addCombo(card, btn); });
  }

  // Shopify standart para bicimlendirme ({{amount}}, {{amount_with_comma_separator}} ...)
  function formatMoney(cents, format) {
    function delim(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return head + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return m ? format.replace(m[0], value) : value;
  }

  function addCombo(card, btn) {
    if (btn.classList.contains('is-loading')) return;
    var rows = card.querySelectorAll('.tc-lb-row');
    var items = [], missing = [];

    rows.forEach(function (r) {
      r.classList.remove('needs-variant');
      if (r.getAttribute('data-available') !== 'true') return; // stokta yok → atla
      var field = r.querySelector('.tc-lb-variant');
      var multi = r.getAttribute('data-multi') === 'true';
      var val = field ? field.value : '';
      if (multi && !val) { missing.push(r); return; }   // beden seçilmemiş
      if (val) items.push({ id: parseInt(val, 10), quantity: 1 });
    });

    if (missing.length) {
      missing.forEach(function (r) { r.classList.add('needs-variant'); });
      flash(btn, 'is-warn', btn.getAttribute('data-msg-select'));
      return;
    }
    if (!items.length) {
      flash(btn, 'is-error', btn.getAttribute('data-msg-none'));
      return;
    }
    submit(card, btn, items);
  }

  function submit(card, btn, items) {
    btn.classList.add('is-loading');
    btn.disabled = true;

    var body = { items: items, sections: CART_SECTIONS, sections_url: window.location.pathname };

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
      })
      .then(function (r) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (!r.ok) {
          var msg = (r.data && (r.data.description || r.data.message)) || btn.getAttribute('data-msg-error');
          console.error('[style-lookbook] /cart/add.js hatası:', r.status, r.data);
          flash(btn, 'is-error', msg);
          return;
        }
        refreshCart(r.data);
        var tpl = btn.getAttribute('data-msg-added') || '{n}';
        flash(btn, 'is-success', tpl.replace('{n}', items.length), 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        console.error('[style-lookbook] ağ hatası:', err);
        flash(btn, 'is-error', btn.getAttribute('data-msg-error'));
      });
  }

  // Sepet drawer'ını tazele (tema Dawn deseni: <cart-drawer>.renderContents)
  function refreshCart(data) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function' && data && data.sections) {
      try { cd.renderContents(data); updateCartCount(); return; }
      catch (e) { console.warn('[style-lookbook] cart-drawer render edilemedi, yedek yönteme geçiliyor', e); }
    }
    // Yedek: en azından sepet ikon sayacını güncelle + tema event'i yayınla
    if (data && data.sections && data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        try {
          var frag = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var inner = frag.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        } catch (e) { /* yut */ }
      }
    }
    updateCartCount();
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // Header'daki sepet rozetini guncelle (Ella: [data-cart-count])
  function updateCartCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (n == null) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = n < 100 ? n : '99+';
        });
      })
      .catch(function () { /* sessiz */ });
  }

  // Buton durumu (renk + metin), sonra eski haline döner
  function flash(btn, cls, text, revertMs) {
    var span = btn.querySelector('.tc-lb-add-text');
    if (btn._orig == null) btn._orig = span ? span.textContent : btn.textContent;
    ['is-success', 'is-error', 'is-warn'].forEach(function (c) { btn.classList.remove(c); });
    btn.classList.add(cls);
    if (span) span.textContent = text; else btn.textContent = text;
    clearTimeout(btn._t);
    btn._t = setTimeout(function () {
      btn.classList.remove(cls);
      if (span) span.textContent = btn._orig; else btn.textContent = btn._orig;
    }, revertMs || 2600);
  }
})();
